import { Token } from 'config/types'
import { ChainIdEnum } from '../network'

const path = '/images/token'

const tokens: Record<string, Token> = {
  TRX: {
    coinGeckoInfo: {
      id: 'tron',
    },
    logo: `${path}/trx.png`,
    displayName: 'TRON',
    name: 'TRX',
    code: 'TRX',
    network: ChainIdEnum.TRX_TESTNET,
    isNative: true,
    decimals: 6,
  },
  USDT: {
    coinGeckoInfo: {
      id: 'tether',
    },
    logo: `${path}/usdt.png`,
    displayName: 'Tether USD',
    name: 'USDT',
    code: 'USDT',
    network: ChainIdEnum.TRX_TESTNET,
    address: 'TXYZopYRdj2D9XRtbG411XZZ3kM5VkAeBf',
    decimals: 6,
    isStable: true,
  },
}

export default tokens
